import { render, staticRenderFns } from "./FormAluno.vue?vue&type=template&id=0df14a5d&scoped=true"
import script from "./FormAluno.vue?vue&type=script&lang=js"
export * from "./FormAluno.vue?vue&type=script&lang=js"
import style0 from "./FormAluno.vue?vue&type=style&index=0&id=0df14a5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df14a5d",
  null
  
)

export default component.exports